import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { MenuItem } from "~/components/section/section-style/section-style-header/section-style-header-menu-item/styles";
import { section as sectionData } from "~/data/section";
import type { sectionStyleHeaderMenuItem$key } from "~/queries/__generated__/sectionStyleHeaderMenuItem.graphql";

type Props = {
  className?: string;
  reference: sectionStyleHeaderMenuItem$key;
};
export const SectionStyleHeaderMenuItem: FunctionComponent<Props> = ({
  className,
  reference: reference_,
}) => {
  const section = useFragment(
    graphql`
      fragment sectionStyleHeaderMenuItem on Section {
        name
        entityId
      }
    `,
    reference_,
  );

  const handleRenderSection = () => {
    if (section.entityId === sectionData.style.entityId) return "Latest Stories";
    return section.name;
  };

  return <MenuItem className={className}>{handleRenderSection()}</MenuItem>;
};

SectionStyleHeaderMenuItem.displayName = "SectionStyleHeaderMenuItem";
